import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { Grid, useTheme } from "@mui/material";
import { ResetDatabase, TicketDatabase } from "../Utils/TicketDatabase";
import { useLiveQuery } from "dexie-react-hooks";

interface Props {
    setReinstallConfirmation(shouldReinstall: boolean): void;
}

export default function ReinstallApplicationConfirmationDialog(props: Props): JSX.Element {
    const theme = useTheme();
    const ticketList = useLiveQuery(async () => TicketDatabase.ticket.toArray());

    if (!ticketList) return <></>;

    const unsyncedTicketCount = ticketList.filter((t) => t.id < 0).length;
    function handleCancelClicked(): void {
        props.setReinstallConfirmation(false);
    }

    function handleDeleteConfirmed(): void {
        ResetDatabase();
    }

    return (
        <Dialog open={true}>
            <Grid container sx={{ p: 2 }}>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Typography component="h1" variant="h6">
                        ARE YOU SURE YOU WANT TO RE-INSTALL?
                    </Typography>
                </Grid>
                <Grid container item xs={12} sx={{ pt: 2 }}>
                    <Grid item flex={1}>
                        {unsyncedTicketCount > 0 && (
                            <Typography textAlign={"center"} color={theme.palette.error.main} sx={{ p: 1, pb: 4 }}>
                                {`${unsyncedTicketCount} TICKET${unsyncedTicketCount === 1 ? "" : "S"} ${
                                    unsyncedTicketCount === 1 ? "HAS" : "HAVE"
                                } NOT BEEN SYNCED. YOU SHOULD CANCEL THIS RE-INSTALL AND CLICK THE SYNC BUTTON FIRST TO AVOID LOSING DATA.`}
                            </Typography>
                        )}
                        <Typography textAlign={"center"} sx={{ p: 1 }}>
                            MAKE SURE YOU HAVE A GOOD DATA CONNECTION BEFORE RE-INSTALLING.
                        </Typography>
                        <Typography textAlign={"center"} sx={{ p: 1 }}>
                            THE APP WILL NOT FUNCTION UNTIL THE RE-INSTALLATION COMPLETES!
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Button variant="contained" sx={{ m: 1 }} onClick={handleCancelClicked}>
                        CANCEL
                    </Button>
                    <Button variant="contained" color={"error"} sx={{ m: 1 }} onClick={handleDeleteConfirmed}>
                        RE-INSTALL
                    </Button>
                </Grid>
            </Grid>
        </Dialog>
    );
}
